import { on } from './events';

// How long a badge step waits for its moment to begin before moving on without it (see the badge step's report).
export const BADGE_MOMENT_WAIT_MS = 6000;
export const badgeMomentStarted = (playingNow, waitMs = BADGE_MOMENT_WAIT_MS) => new Promise(resolve => {
  if (playingNow()) {
    resolve('playing');
    return;
  }
  let off = () => {};
  const timer = setTimeout(() => {
    off();
    resolve('timeout');
  }, waitMs);
  off = on('badge-moment', ({ playing }) => {
    if (!playing) return;
    clearTimeout(timer);
    off();
    resolve('playing');
  });
});
